import { z } from 'zod'

/**
 * Schema for creating a new misc category
 */
export const MiscCategoryCreateSchema = z.object({
  name: z.string().min(1).max(50),
})
export type MiscCategoryCreateInput = z.infer<typeof MiscCategoryCreateSchema>

/**
 * Schema for updating an existing misc category
 */
export const MiscCategoryUpdateSchema = z.object({
  miscCategoryGuid: z.string().uuid(),
  patch: z
    .object({
      name: z.string().min(1).max(50).optional(),
      isActive: z.boolean().optional(),
    })
    .refine(p => Object.keys(p).length > 0, 'No-op update'),
})
export type MiscCategoryUpdateInput = z.infer<typeof MiscCategoryUpdateSchema>

/**
 * Schema for misc category response
 */
export const MiscCategoryResponseSchema = z.object({
  miscCategoryGuid: z.string().uuid(),
  companyGuid: z.string().uuid(),
  name: z.string(),
  isActive: z.boolean(),
  createdByUserGuid: z.string().uuid(),
  lastEditedByUserGuid: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type MiscCategoryResponse = z.infer<typeof MiscCategoryResponseSchema>
